import { motion } from "framer-motion";
import { FadeIn } from "@/components/animated";
import { AnimatedCounter } from "@/components/animated";
import { stats } from "@/data/homePageData";
import { Users, TrendingUp, BookOpen, Star } from "lucide-react";

const iconMap: Record<string, React.ComponentType<{ className?: string }>> = {
  "1": Users,
  "2": TrendingUp,
  "3": BookOpen,
  "4": Star,
};

export function StatisticsSection() {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-primary-50/30">
      <div className="container">
        <FadeIn>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-center text-secondary-900 mb-4">
            Números que hablan por sí solos
          </h2>
          <p className="text-center text-secondary-600 max-w-2xl mx-auto mb-16">
            Miles de profesionales confían en ARCUS Learning para alcanzar
            resultados
          </p>
        </FadeIn>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => {
            const Icon = iconMap[stat.id] || Users;
            return (
              <motion.div
                key={stat.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1, duration: 0.5 }}
                className="text-center group"
              >
                <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-600 group-hover:text-white transition-colors duration-300">
                  <Icon className="h-7 w-7" />
                </div>

                <div className="mb-2">
                  <AnimatedCounter
                    value={stat.value}
                    suffix={stat.suffix}
                    decimals={stat.id === "4" ? 1 : 0}
                    className="text-4xl md:text-5xl font-display font-bold text-gradient"
                  />
                </div>

                <h3 className="text-lg font-semibold text-secondary-900 mb-1">
                  {stat.label}
                </h3>
                <p className="text-sm text-secondary-500">{stat.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
